module.exports = __webpack_public_path__ + "img/ic_college.403bf60d.png";